import { Configuration, PaymentsApi } from '@/api';
import { PaymentMethodSetup } from '@/models/PaymentMethod';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useMutation } from '@tanstack/react-query';

const useCreatePaymentMethodSetup = () => {
  const paymentsApi = new PaymentsApi(new Configuration(useAuth));

  const mutation = useMutation<PaymentMethodSetup>({
    mutationFn: () => paymentsApi.createPaymentMethodSetup(),
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 5000),
  });

  return {
    createSetup: mutation.mutateAsync,
    setup: mutation.data,
    isLoading: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
};

export default useCreatePaymentMethodSetup;
